'use client';

import { useCallback, useEffect, useState } from 'react';
import { SITE } from '@/app/constants';
import { cn } from '@/app/utils';
import { renderAWSCaptcha } from '@/app/utils/client';

declare global {
  interface Window {
    showAWSCaptcha?: () => Promise<void>;
  }
}

export function AWSCaptcha() {
  const [isVisible, setIsVisible] = useState(false);

  const showCaptcha = useCallback(async () => {
    // 显示验证码
    setIsVisible(true);
    try {
      // 等待下一个渲染周期
      await new Promise((resolve) => setTimeout(resolve, 0));
      await renderAWSCaptcha();
    } finally {
      setIsVisible(false);
    }
  }, []);

  useEffect(() => {
    window.showAWSCaptcha = showCaptcha;
    return () => {
      window.showAWSCaptcha = undefined;
    };
  }, [showCaptcha]);

  if (SITE !== 'global') {
    return null;
  }

  return (
    <div
      className={cn(
        'fixed inset-0 z-[1000] flex items-center justify-center bg-black/65',
        isVisible ? 'visible' : 'invisible',
      )}
      style={{
        // 确保容器有明确的尺寸，防止SDK计算错误
        minHeight: '100vh',
        minWidth: '100vw',
      }}
    >
      <div
        id="aws-captcha-container"
        className="rounded-8 bg-white p-4"
        style={{
          minHeight: '200px',
          // 为容器设置最小尺寸，确保SDK有足够空间渲染
          minWidth: '320px',
          position: 'relative',
        }}
      />
    </div>
  );
}
